import axios, {AxiosInstance} from "axios";

export default class BackOfficeService {

  public static api: AxiosInstance

  public static init(): void {
    BackOfficeService.api = axios.create({
      baseURL: '/',
      withCredentials: false,
    });
  }

  public static fetchLocaleText(locale: string): Promise<any> {
    return BackOfficeService.api.get(`/locales/text/${locale}.json`).then((r) => r.data)
      .catch(async () => {
        return await BackOfficeService.api.get(`/locales-legacy/text/${locale}.json`).then((r) => r.data);
      });
  }
}
